import { LOANREQUEST_STATUSES } from 'cpool-constants';
import type { Schema_Status } from 'cpool-schemas';

export const getSubStatusTranslationPath = (status: Schema_Status) => {
    switch (status.status) {
        case LOANREQUEST_STATUSES.INITIAL:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.INITIAL}.${status.subStatus}` as const;
        case LOANREQUEST_STATUSES.IN_PROGRESS:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.IN_PROGRESS}.${status.subStatus}` as const;
        case LOANREQUEST_STATUSES.OFFER_AT_BANK:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.OFFER_AT_BANK}.${status.subStatus}` as const;
        case LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.OFFER_AT_CUSTOMER}.${status.subStatus}` as const;
        case LOANREQUEST_STATUSES.APPROVED:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.APPROVED}.${status.subStatus}` as const;
        case LOANREQUEST_STATUSES.CANCELED:
            if (!status.subStatus) return null;
            return `STATUS.${LOANREQUEST_STATUSES.CANCELED}.${status.subStatus}` as const;
        default:
            return null;
    }
};
